import { render } from "./product-compare-kicker.vue?vue&type=template&id=31b78a17"
import script from "./product-compare-kicker.vue?vue&type=script&lang=js"
export * from "./product-compare-kicker.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\MVC\\wwwroot\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__